<div class="park card shadow-sm {{ active ? 'active' : '' }}">
  <div class="card-header text-primary  pb-3">
    <div class="row mb-3">
      <div class="font-weight-bold font-size-medium clickable" (click)="redirectToAsset.emit(asset)">
        {{ asset.fe_name }}
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        @if (!!asset?.actualPower ) {
          <div>
            {{'COMPONENT_LIBRARY.MAP.ACT' | translate}} {{'COMPONENT_LIBRARY.MAP.POWER' | translate}}:
            <span class="font-weight-bold">{{ asset?.actualPower | convertPower: 'MW' | number:'1.2-2' | customNumberFormat }} MW</span>
          </div>
        }
        @if (!!asset?.ratedPower) {
          <div>
            {{'COMPONENT_LIBRARY.MAP.RATED' | translate}} {{'COMPONENT_LIBRARY.MAP.POWER' | translate}}:
            <span class="font-weight-bold">{{ asset?.ratedPower | convertPower: 'MW' | number:'1.2-2' | customNumberFormat }} MW</span>
          </div>
        }
        @if (!!asset?.lostPower) {
          <div>
            {{'COMPONENT_LIBRARY.MAP.LOSS' | translate}} {{'COMPONENT_LIBRARY.MAP.POWER' | translate}}:
            <span class="font-weight-bold">{{ asset?.lostPower | convertPower: 'MW' | number:'1.2-2' | customNumberFormat }} MW</span>
          </div>
        }
      </div>
      <div class="col-6 text-right text-tertiary">
        @for (typeString of turbineTypeStrings; track typeString.type) {
          <div>
            {{ typeString.type }}
            <span class="d-inline-block">{{ typeString.height }}</span>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="card-body border-top">
    <div class="row" style="padding:0  0.5rem">
      @for (asset of subAssets; track (asset.code ?? asset.name ); let i = $index) {
        <div class="col-3 text-primary p-2 clickable"
          [class.d-none]="!showAll && i > turbinesLimit"
          (click)="redirectToSubAsset.emit(asset)"
          [ngStyle]="{'pointer-events': cantRedirectToSubAsset ? 'auto' : 'none'}">
          @if (statusColors) {
            <i class="fas fa-circle turbine-status mr-1"
            [ngStyle]="{'color': asset ?  (statusColors[asset.status[statusHour]]) : '' }"></i>
          }
          @if (!statusColors) {
            <i class="fas fa-circle turbine-status mr-1"
            [ngStyle]="{'color': asset ?  (asset?.status | colorStatusCode:'color') : (asset?.status | statusCode:'color') }"></i>
          }
          <span class="font-weight-bold">{{ asset?.code ? (asset?.code | noUnderscore) : asset?.name }}</span>
        </div>
      }
    </div>
  </div>
  @if (subAssets.length > turbinesLimit + 1) {
    <div class="card-footer border-top">
      <div class="text-tertiary d-flex align-items-center justify-content-center clickable" (click)="toggleShowAll($event)">
        <span class="font-weight-bold">
          {{ showAll ? 'Show less' : 'Show all (' + subAssets.length + ')' }}
        </span>
        <span class="d-flex align-items-center justify-content-center">
          <i class="material-icons">{{ showAll ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</i>
        </span>
      </div>
    </div>
  }
</div>
